
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMenu as ObiMenuElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-menu.js';
 
 
 

 
 export const ObiMenu = createComponent({
   react: React,
   tagName: 'obi-menu',
   elementClass: ObiMenuElement,
   events: {
     
   }
  });
 
 